// extracted by mini-css-extract-plugin
export default {"container":"ImageUploader_container__R7X4c","imageContainer":"ImageUploader_imageContainer__xhYFA","uploadButton":"ImageUploader_uploadButton__4TvOW"};